/* eslint-disable no-unused-vars */
/* eslint-disable no-undef eslint-disable-next-line no-unused-vars */
<template>
  <v-container
    class="pt-0 mt-0 pb-0 mb-0 no-gutters fluid"
    fluid
  >
    <v-row
      class="pt-0 mt-0 pb-1 mb-1 no-gutters fluid"
    >
      <v-col
        cols="12"
      >
        <grid
          :data-source="deviceItems"
          :selectable="'row'"
          :sortable="true"
          :filterable-mode="'row'"
          :groupable="false"
          :height="730"
          @change="onChange"
        >
          <kendo-grid-column
            :field="'idDokument'"
            :title="'Id'"
            :width="100"
            :hidden="true"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
          <kendo-grid-column
            :field="'nameGeraet'"
            :title="'Fahrzeug-Name'"
            :width="240"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
          <kendo-grid-column
            :field="'telNrGeraet'"
            :title="'Fahrzeug-Tel.-Nr'"
            :width="240"
            :filterable-cell-operator="'contains'"
            :filterable-cell-show-operators="false"
          />
          <kendo-grid-column
            :field="'datumReferenzStart'"
            :title="'Trackin-Zeit von'"
            :type="'date'"
            :format="'{0: dd.MM.yyyy}'"
            :filterable="false"
          />
          <kendo-grid-column
            :field="'datumReferenzStop'"
            :title="'Trackin-Zeit bis'"
            :type="'date'"
            :format="'{0: dd.MM.yyyy}'"
            :filterable="false"
          />
          <kendo-grid-column
            :field="'datumZeitErzeugung'"
            :title="'Erzeugung-Zeit'"
            :type="'date'"
            :format="'{0: dd.MM.yyyy}'"
            :filterable="false"
          />
        </grid>
      </v-col>
    </v-row>
    <v-row class="pt-0 mt-0 pb-1 mb-1 no-gutters fluid">
      <v-col
        cols="2"
      >
        <h5 class="font-weight-light">
          Dokument lokal
        </h5>
      </v-col>
      <v-col

        cols="3"
      >
        <v-spacer />
        <v-btn
          @click="getPdfDocument"
        >
          Download
        </v-btn>
      </v-col>

      <v-col
        cols="1"
      >
        <v-spacer />
        <h5 class="font-weight-light pr-2">
          Email
        </h5>
      </v-col>

      <v-col
        cols="4"
      >
        <v-text-field
          v-model="SendTo"
          class="pr-10"
          outlined
          label="E-Mail: "
          dense
        />
      </v-col>

      <v-col
        cols="2"
      >
        <v-spacer />
        <v-btn
          class="ma-0 pa-0 !important"
          @click="mailPdfDocument"
        >
          E-Mail Senden An
        </v-btn>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-overlay :value="info">
      <h5>
        <p>{{ infoMessage }}</p>
        <p>
          <v-btn
            color="warning"
            @click="info = false"
          >
            Ok
          </v-btn>
        </p>
      </h5>
    </v-overlay>
    <v-overlay :value="fault">
      <h5>
        <p>{{ faultMessage }}</p>
      </h5>
      <p>
        <v-btn
          color="error"
          @click="fault = false"
        >
          ok
        </v-btn>
      </p>
    </v-overlay>
  </v-container>
</template>
<script>
  import { Grid } from '@progress/kendo-grid-vue-wrapper'
  import client from './../../../../shared/apicllient/AuthenticatedClient'

  export default {
    components: {
      Grid,
    },
    data () {
      return {
        deviceItems: [],
        vonDateString: this.$route.query.von,
        bisDateString: this.$route.query.bis,
        timestamp: '',
        id: 0,
        // --> Here Map
        visible: false,
        printTable: true,
        printGrafic: true,
        SendTo: '',
        lastPrints: true,
        overlay: false,
        info: false,
        infoMessage: '',
        fault: false,
        faultMessage: '',
      }
    },
    watch: {
      '$route' (to, from) {
        this.overlay = false
        this.vonDateString = to.query.von
        this.bisDateString = to.query.bis
        this.lastPrints = to.query.lastPrints
        this.printDevices()
      },
    },
    created () {
      this.visible = true
      this.printDevices()
    },
    mounted () {
      this.SendTo = process.env.VUE_APP_SENDMAIL
      console.log(process.env.VUE_APP_SENDMAIL)
      this.visible = true
    },
    methods: {
      onChange (e) {
        const items = e.sender.select()
        this.id = parseInt(items[0].children[0].innerText)
        console.log(this.id)
      },
      printDevices () {
        this.overlay = true
        client.post(process.env.VUE_APP_API + '/device/printdevicelist', {
          Von: this.vonDateString,
          Bis: this.bisDateString,
          NurLetzteDrucke: this.lastPrints,
        }).then(response => {
          this.deviceItems = response.data
          console.log(response.data)
          this.overlay = false
        }).catch(error => {
          this.overlay = false
          console.log(error)
        })
      },
      mailPdfDocument () {
        if (this.id === 0) {
          this.infoMessage = 'Bitte wählen Sie ein Dokument aus !'
          this.info = true
          return
        }

        this.overlay = true
        client.post(process.env.VUE_APP_API + '/device/mailpdfdocument', {
          Id: this.id,
          SendTo: this.SendTo,
        }).then(response => {
          this.overlay = false
        }).catch(error => {
          this.overlay = false
          console.log(error)
        })
      },
      getPdfDocument () {
        if (this.id === 0) {
          this.infoMessage = 'Bitte wählen Sie ein Dokument aus !'
          this.info = true
          return
        }
        this.overlay = true
        client.post(process.env.VUE_APP_API + '/device/pdfdocument', {
          Von: this.vonDateString,
          Bis: this.bisDateString,
          Id: this.id,
        }, { responseType: 'blob' }).then(response => {
          // const arrBuffer = base64ToArrayBuffer(base64Data)

          const file = new Blob([response.data], { type: 'application/pdf' })

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file)
            this.overlay = false
            return
          }
          const fileURL = URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = fileURL
          link.download = 'NetToWin-Bericht.pdf'
          document.body.appendChild(link)
          link.click()
          this.overlay = false
          setTimeout(function () {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(fileURL)
          }, 100)
        })
          .catch(error => {
            console.log(error)
          })
      },

    },
  }
</script>
<style lang="scss" scoped>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    .capture-panel{
      display: inline-block;
      width: 100%;
      height: 835px;
      border: 1px solid red;
    }
    .checkbox-align {
      margin: 0px;
      padding: 0px;
    }
  .v-btn {
    min-width: 0;
  }
</style>
